(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('DocumentWorkItemActionDeleteController',DocumentWorkItemActionDeleteController);

    DocumentWorkItemActionDeleteController.$inject = ['$uibModalInstance', 'entity', 'DocumentWorkItemAction'];

    function DocumentWorkItemActionDeleteController($uibModalInstance, entity, DocumentWorkItemAction) {
        var vm = this;

        vm.documentWorkItemAction = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            DocumentWorkItemAction.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
